import { useState } from "react";
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
export default () => {
  const navigate = useNavigate();
  const [confirmDeleteJob, setConfirmDeleteJob] = useState(false);
  const [loadingToapi, setloadingToapi] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const queryClient = useQueryClient();
  const [jobIdToDelete, setJobIdToDelete] = useState(null);
  const userData = useSelector((state) => state.app.userData.userData);

  const baseURL = process.env.REACT_APP_BASE_URL;
  const fetchjobsListing = async ({ queryKey }) => {
    const [, status, page] = queryKey;
    const { data } = await axios.get(`${baseURL}/api/v2/job?page=${page}`, {
      params: {
        company_id: userData?.employer?.id,
        total_job_views: userData?.employer?.id,
        total_favourite: userData?.employer?.id,
        is_active: status,
      },
    });
    return data?.data;
  };
  const {
    data: jobslisting,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["jobslisting", activeTab, currentPage],
    queryFn: fetchjobsListing,
    enabled: activeTab === 1 || activeTab === 0,
  });
  const { has_more_pages, total_pages } = jobslisting || {};
  const deleteJobMutation = useMutation({
    mutationFn: (jobId) => axios.delete(`${baseURL}/api/job-postings/${jobId}`),
    onSuccess: () => {
      setConfirmDeleteJob(false);
      setloadingToapi(false);
      queryClient.invalidateQueries(["jobsListing"]);
    },
    onError: (err) => {
      console.error("Error deleting job:", err);
      setloadingToapi(false);
    },
  });

  const handleDeleteJob = (id) => {
    setloadingToapi(true);
    setloadingToapi(id);
    deleteJobMutation.mutate(id);
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Job Listing: {error.message}
        </p>
      </div>
    );
  }
  return {
    jobslisting,
    navigate,
    setActiveTab,
    activeTab,
    isLoading,
    loadingToapi,
    setCurrentPage,
    currentPage,
    total_pages,
    has_more_pages,
    confirmDeleteJob,
    setConfirmDeleteJob,
    jobIdToDelete,
    setJobIdToDelete,
    handleDeleteJob,
  };
};
